import Login from './Login';

export default Login;



// WEBPACK FOOTER //
// ./src/client/Pages/Auth/Login/index.js